import React from "react";
import Modal from "../../Modal";

export default function ReserveError({ title, detail }) {
  const { phrases = {} } = window;
  return (
    <Modal
      title={title}
      modalView="xs"
      cssModifyer="reserve-error"
    >
      <div className="form-content">
        <div className="form-cont-row">
          <p>
            <span>
              {detail}
            </span>
          </p>
        </div>
        <button className="wb-btn btn-yellow js-close">{phrases.general?.close || "Close"}</button>
      </div>
    </Modal>
  );
}
